import { createSystem, defaultConfig } from '@chakra-ui/react';

import { raspberryBaseTheme } from './base';

/**
 * Additional styles for APP (not included in web component styles)
 */
const raspberryAppTheme = createSystem(defaultConfig, raspberryBaseTheme, {
    globalCss: {
        '*': {
            focusRing: 'none',
            focusVisibleRing: 'outside',
            focusRingColor: '{colors.focusRing}',
        },

        ':where(a[href]:not([class]))': {
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            textDecorationColor: 'currentColor/20',
        },
    },
});

export default raspberryAppTheme;
